import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

// Available languages - English, Arabic
export const LANGUAGES = {
  en: { code: "en", name: "English", dir: "ltr", flag: "🇺🇸" },
  ar: { code: "ar", name: "العربية", dir: "rtl", flag: "🇵🇸" },
};

const STORAGE_KEY = "classmate_language";

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem(STORAGE_KEY) || "en";
  });

  useEffect(() => {
    const lang = LANGUAGES[language] || LANGUAGES.en;
    document.documentElement.dir = lang.dir;
    document.documentElement.lang = lang.code;
    if (typeof window !== "undefined") {
      localStorage.setItem(STORAGE_KEY, language);
    }
  }, [language]);

  const changeLanguage = (newLang) => {
    if (LANGUAGES[newLang]) {
      setLanguage(newLang);
    }
  };

  const isRTL = LANGUAGES[language]?.dir === "rtl";

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
        isRTL,
        languages: LANGUAGES,
        currentLanguage: LANGUAGES[language] || LANGUAGES.en,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
